const links = [
    {   
        linkName: "Home",
        link: "",
        subLinks: [
            {
                subLinkName: "Travel Agency",
                subLink: "/#wrapper",
            },
            {
                subLinkName: "Destination",
                subLink: "/#travel",
            },
            {
                subLinkName: "Summer Holidays",
                subLink: "/#tours",
            },
            {
                subLinkName: "Our team",
                subLink: "/#team",
            },
            {
                subLinkName: "Country Tours",
                subLink: "/#countries",
            },
            {
                subLinkName: "Top Reviews",
                subLink: "/#reviews",
            },
            {
                subLinkName: "About us",
                subLink: "/#footer",
            },
            
        ]
    },
    {   
        linkName: "Tours",
        link: "tours",
        subLinks: [
            {
                subLinkName: "Travel",
                subLink: "/tours#wrapper",
            },
            {
                subLinkName: "Gallery List",
                subLink: "/tours#tourList",
            },
            {
                subLinkName: "Filter Tours",
                subLink: "/tours#filter",
            },
            {
                subLinkName: "About us",
                subLink: "/tours#footer",
            }
        ]
    },
    {
        linkName: "Blog",
        link: "blog",
        subLinks: [
            {
                subLinkName: "Blog Standard",
                subLink: "#",
            },
            {
                subLinkName: "Blog Details",
                subLink: "/blog#blogDetails",
            },
            {
                subLinkName: "About Author",
                subLink: "/blog#about",
            },
            {
                subLinkName: "Comments",
                subLink: "/blog#comments",
            },
            {
                subLinkName: "About us",
                subLink: "/blog#footer",
            }
        ]
    },
    {
        linkName: "Pages",
        link: "pages",
        subLinks: [
            {
                subLinkName: "Page",
                subLink: "/pages#",
            },
            {
                subLinkName: "What we offer",
                subLink: "/pages#",
            },
            {
                subLinkName: "Our Team",
                subLink: "/pages#",
            },
            {
                subLinkName: "Get In Touch",
                subLink: "/pages#",
            },
            {
                subLinkName: "Contact Us",
                subLink: "/pages#",
            },
            {
                subLinkName: "Coming soon",
                subLink: "/pages#",
            },
            {
                subLinkName: "Error Page",
                subLink: "/pages#",
            },
            
        ]
    },
    {   
        linkName: "Destinations",
        link: "destinations",
        subLinks: [
            {
                subLinkName: "Destination List",
                subLink: "/destinations#",
            },
            {
                subLinkName: "Destination Slider",
                subLink: "/destinations#",
            },
            {
                subLinkName: "Destination Item",
                subLink: "/destinations#",
            }
        ]
    },
]

export default links